import { useEffect } from 'react';

import { useMunicipalities } from '@utils/queries/map.queries';
import { useSelector } from 'react-redux';

const Municipality = ({ map, choosedCountry }) => {
  const { data: municipalities } = useMunicipalities(choosedCountry.value, choosedCountry.data);
  const currentBaseMapStyle = useSelector(state => state.maplibreMap.currentBaseMapStyle)

  useEffect(() => {
    map.addLayer({
      id: 'municipalities',
      type: 'line',
      source: {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: [],
        },
      },
      paint: {
        'line-color': '#022741',
        'line-width': 2,
      },
    }, 'z-index-8');

    return () => {
      if (map && !map._removed) {
        if (map.getLayer('municipalities')) {
          map.removeLayer('municipalities');
        }
  
        if (map.getSource('municipalities')) {
          map.removeSource('municipalities');
        }
      }
    };
  }, [map, currentBaseMapStyle]);

  useEffect(() => {
    if (municipalities) {
      map.getSource('municipalities').setData(municipalities);
    }
  }, [map, municipalities, currentBaseMapStyle]);
}

export default Municipality